import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/NotFound";
import { Route, Switch } from "wouter";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./contexts/ThemeContext";
import { ClientAuthProvider } from "./contexts/ClientAuthContext";
import { I18nProvider } from "./contexts/I18nContext";
import { LanguageSync } from "./components/LanguageSync";
import Home from "./pages/Home";
import Funnel from "./pages/Funnel";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import Video from "./pages/Video";
import Erleben from "./pages/Erleben";
import Termin from "./pages/Termin";
import TerminDanke from "./pages/TerminDanke";
import Angebot from "./pages/Angebot";
import Registrierung from "./pages/Registrierung";
import Buch from "./pages/Buch";
import BuchDanke from "./pages/BuchDanke";
import Agb from "./pages/Agb";
import AyuErleben from "./pages/AyuErleben";
import DemoRedirect from "./pages/DemoRedirect";
import DemoRegistration from "./pages/DemoRegistration";
import MasterclassHealth from "./pages/MasterclassHealth";
import MasterclassBeauty from "./pages/MasterclassBeauty";
import CookieBanner from "./components/CookieBanner";
import BusinessEvent from "./pages/BusinessEvent";
import EventSuccess from "./pages/EventSuccess";
import EventDanke from "./pages/EventDanke";
import EventAdmin from "./pages/EventAdmin";

// App Pages (Client Area)
import ClientLogin from "./pages/app/ClientLogin";
import AppLayout from "./pages/app/AppLayout";
import AppDashboard from "./pages/app/AppDashboard";
import AppTagebuch from "./pages/app/AppTagebuch";
import AppAyuCoach from "./pages/app/AppAyuCoach";
import AppKompass from "./pages/app/AppKompass";
import AppProfil from "./pages/app/AppProfil";
import AppHilfe from "./pages/app/AppHilfe";
import AppOnboarding from "./pages/app/AppOnboarding";
import AppAdmin from "./pages/app/AppAdmin";
import AppCommunity from "./pages/app/AppCommunity";
import AppDocuments from "./pages/app/AppDocuments";
import AppSessions from "./pages/app/AppSessions";
import AppMicrobiome from "./pages/app/AppMicrobiome";
import AppNutritionProfile from "./pages/app/AppNutritionProfile";
import AppDinacharya from "./pages/app/AppDinacharya";
import AppRezepte from "./pages/app/AppRezepte";
import AppFortschritt from "./pages/app/AppFortschritt";
import AppGamification from "./pages/app/AppGamification";
import AppProgramme from "./pages/app/AppProgramme";
import AppWearables from "./pages/app/AppWearables";
import AppSchlaf from "./pages/app/AppSchlaf";
import AppFeedback from "./pages/app/AppFeedback";
import AppFeedbackAcknowledgement from "./pages/app/AppFeedbackAcknowledgement";
import AppCheckIn from "./pages/app/AppCheckIn";
import AppHoerbuch from "./pages/app/AppHoerbuch";

function Router() {
  return (
    <Switch>
      {/* Public Landing Pages */}
      <Route path={"/"} component={Home} />
      <Route path={"/funnel"} component={Funnel} />
      <Route path={"/impressum"} component={Impressum} />
      <Route path={"/datenschutz"} component={Datenschutz} />
      <Route path={"/video"} component={Video} />
      <Route path={"/erleben"} component={Erleben} />
      <Route path={"/termin/danke"} component={TerminDanke} />
      <Route path={"/termin"} component={Termin} />
      <Route path={"/angebot"} component={Angebot} />
      <Route path={"/registrierung"} component={Registrierung} />
      <Route path={"/buch/danke"} component={BuchDanke} />
      <Route path={"/buch"} component={Buch} />
      <Route path={"/agb"} component={Agb} />
      <Route path={"/ayu-erleben"} component={AyuErleben} />
      <Route path={"/masterclass-health"} component={MasterclassHealth} />
      <Route path={"/masterclass-beauty"} component={MasterclassBeauty} />
      <Route path={"/demo"} component={DemoRegistration} />
      <Route path={"/demo-erleben"} component={DemoRegistration} />

      {/* Business Event */}
      <Route path={"/event/admin"} component={EventAdmin} />
      <Route path={"/event/danke"} component={EventDanke} />
      <Route path={"/event/success"} component={EventSuccess} />
      <Route path={"/event"} component={BusinessEvent} />

      {/* Client Login */}
      <Route path={"/login"} component={ClientLogin} />
      <Route path={"/app/login"} component={ClientLogin} />

      {/* Onboarding (Protected but outside AppLayout - no sidebar needed) */}
      <Route path="/app/onboarding" component={AppOnboarding} />
      {/* Check-In (Protected but outside AppLayout - fullscreen wizard) */}
      <Route path="/app/check-in" component={AppCheckIn} />

      {/* Client App (Protected by AppLayout) */}
      <Route path="/app" nest>
        <AppLayout>
          <Switch>
            <Route path="/" component={AppDashboard} />
            <Route path="/tagebuch" component={AppTagebuch} />
            <Route path="/ayu-coach" component={AppAyuCoach} />
            <Route path="/sessions" component={AppSessions} />
            <Route path="/hoerbuch" component={AppHoerbuch} />
            <Route path="/kompass" component={AppKompass} />
            <Route path="/profil" component={AppProfil} />
            <Route path="/hilfe" component={AppHilfe} />
            <Route path="/community" component={AppCommunity} />
            <Route path="/dokumente" component={AppDocuments} />
            <Route path="/mikrobiom" component={AppMicrobiome} />
            <Route path="/ernaehrungsprofil" component={AppNutritionProfile} />
            <Route path="/tagesroutine" component={AppDinacharya} />
            <Route path="/rezepte" component={AppRezepte} />
            <Route path="/fortschritt" component={AppFortschritt} />
            <Route path="/programme/:programId?" component={AppProgramme} />
            <Route path="/gamification" component={AppGamification} />
            <Route path="/schlaf" component={AppSchlaf} />
            <Route path="/wearables" component={AppWearables} />
            <Route path="/feedback" component={AppFeedback} />
            <Route path="/feedback/acknowledgement/:ticketId" component={AppFeedbackAcknowledgement} />
            <Route path="/check-in" component={AppCheckIn} />
            <Route path="/admin" component={AppAdmin} />
            <Route component={NotFound} />
          </Switch>
        </AppLayout>
      </Route>

      <Route path={"/404"} component={NotFound} />
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider defaultTheme="light">
        <I18nProvider>
          <ClientAuthProvider>
            <LanguageSync />
            <TooltipProvider>
              <Toaster />
              <Router />
              <CookieBanner />
            </TooltipProvider>
          </ClientAuthProvider>
        </I18nProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
